import React, { useContext } from 'react'
import { GlobalDataContext } from '../../../context/context'
import { ButtonContent } from '../boton/ButtonContent'
import Navmenu from './NavMenu'



const Header7 = () => {

    const { rpdata } = useContext(GlobalDataContext)

    return (
        <header 
        className='absolute right-[3%] left-[3%] z-[15] bg-slate-800 bg-cover bg-center bg-no-repeat px-4 py-5 lg:px-6 my-6 rounded-[40px] md:rounded-[80px]'
        style={{
            backgroundImage: 'url("https://firebasestorage.googleapis.com/v0/b/stockredesdirectorios.appspot.com/o/image.png?alt=media&token=a68fe540-566f-4fd1-ad25-d957a5d1c929")'
        }}
        >
            <div className='flex flex-row-reverse lg:flex-row'>
                <div className='w-full flex items-center  md:w-[75%] lg:w-[25%] '>
                    <img
                        src={rpdata?.dbPrincipal?.logo}
                        alt='logo'
                        loading='lazy'
                        className='w-[70%] md:w-[50%] object-contain mx-auto'
                    />
                </div>

                <div className='block w-[20%] lg:w-[75%] self-center'>
                    <div className='flex'>
                        <div className='w-[25%] lg:w-[75%] flex items-center justify-start'>
                            {
                                rpdata?.simpleWidgets?.[3]?.activo ?
                                    null
                                    :
                                    <nav>
                                        <Navmenu />
                                    </nav>
                            }
                        </div>
                        <div className=' hidden lg:block w-[45%] lg:w-[25%] text-end border-l ml-0 lg:ml-7'>
                            <ButtonContent />
                        </div>
                    </div>
                </div>

            </div>
        </header>
    )
}

export default Header7
